<details (click)="recalcMaxWidth()" onmouseleave="window.matchMedia('(min-width: 1280px)').matches ? this.open = false : null">
    <summary>{{ 'CATALOG.SORT.LABEL' | translate }}</summary>
    @for( sort of _sortings; track sort.id) {
    <label>
        <input type="radio"
        name="sorting"
        [id]="sort?.id"
        [attr.checked]="sort?.selected ? '' : null"
        [value]="sort?.id"
        (input)="updateUrl()"
        >
        <span>{{ 'CATALOG.SORT.'+sort?.id | uppercase | translate }}</span>
    </label>
    }
</details>
